import CryptoJS from "crypto-js";
import { base64 } from "js-md5";
let KEY = 'tfleat3tbdtdbtc2'
let crypto = {
	/*aes加密*/
	setAES(str) {
		const data = CryptoJS.enc.Utf8.parse(str);
		const key = CryptoJS.enc.Utf8.parse(KEY);
		var option = {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		};
		var encrypted = CryptoJS.AES.encrypt(data, key, option).toString();
		return window.btoa(encrypted);
	},
	/*aes解密*/
	decryptAES(word) {		
		let a = CryptoJS.enc.Base64.parse(word).toString(CryptoJS.enc.Utf8) 
		let keyStr = KEY;
		let key = CryptoJS.enc.Utf8.parse(keyStr);
		let decrypted = CryptoJS.AES.decrypt(a,key, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		});
		return CryptoJS.enc.Utf8.stringify(decrypted).toString();
	},	

};

export default crypto;